import React, { Component } from "react";
import { isObject } from "lodash";
import moment from "moment";
import { _, isNil } from "lodash";
import endsWith from "lodash/endsWith";

import MainNav from "../framework/MainNav";
import LocalStorage from "../framework/LocalStorage";
import HomeNav from "../framework/Nav/HomeNav";
import Dashboard from "../../containers/Dashboard";

import { getUrlParameterByName } from "../../utils/utility";
import IdleTimer from "react-idle-timer";

class App extends Component {
  gotoOptimize() {
    if (
      this.props.optimizeUserDetail &&
      this.props.optimizeUserDetail.baroUser
    ) {
      let optimizeHost =
        window.location.hostname.indexOf("audienceanywhere.com") >= 0
          ? "https://optimize-" + window.location.hostname
          : "https://optimize-qa.audienceanywhere.com";
      optimizeHost = optimizeHost.replace("optimize-app", "optimize");

      const token = localStorage.getItem("aa_access_token");
      window.location.replace(
        optimizeHost + "?token=" + token.replace("Bearer ", ""),
      );
    } else {
      window.location.replace("/login");
    }
  }
  redirectIdo() {
    if (
      this.props.optimizeUserDetail &&
      !endsWith(window.location.href, "/myProfile")
    ) {
      if (
        this.props.optimizeUserDetail &&
        this.props.optimizeUserDetail.aaUser &&
        parseInt(
          this.props.optimizeUserDetail.aaUser.subscriptionTierId,
          10,
        ) === 5
      ) {
        this.gotoOptimize();
      }
      if (
        this.props.loginUserDetail &&
        this.props.loginUserDetail.baroUid &&
        !this.props.optimizeUserDetail &&
        this.props.loadingOptimizeUserDetail === false
      ) {
        this.gotoOptimize();
      }
    } else if (!this.props.optimizeUserDetail) {
      if (this.props.loadingOptimizeUserDetail === false) {
        if (process.env.NODE_ENV !== 'development') {
          let optimizeHost =
            window.location.hostname.indexOf("audienceanywhere.com") >= 0
              ? "https://optimize-" + window.location.hostname
              : "https://optimize-qa.audienceanywhere.com";
          optimizeHost = optimizeHost.replace("optimize-app", "optimize");

          const token = localStorage.getItem("aa_access_token");
          window.location.replace(
            optimizeHost + "?token=" + token.replace("Bearer ", ""),
          );
          console.log(this.props);
        }
      }
    }
  }
  componentDidMount() {
    if (isObject(this.session) /*&& window.localStorage.getItem("session")*/) {
      this.props.mountSession(this.session);
      //this.props.getUserClients(this.session.userId)
      if (
        !/(\/create-internal-account|\/create-client-account|\/create-business-unit-member-account)/g.test(
          this.props.location.path,
        )
      ) {
        this.props.getCurrentUserClients();
      }
      if (!this.props.demoAttributes) {
        // console.log(getUrlParameterByName("cid"));
        this.props.loadAttributes(getUrlParameterByName("cid"));
      }
      //this.props.validateSession();
    } else {
      this.session = {};

      if (this.isLoginRequired(this.props.location.path)) {
        const redirectUrl =
          window.location.pathname +
          window.location.search +
          window.location.hash;
        window.location.replace(
          "login?redirect=" + encodeURIComponent(redirectUrl),
        );
      }
    }
    this.redirectIdo();

    setInterval(
      function () {
        this.props.getAPIBuildNumber();
        this.activeAction();
      }.bind(this),
      600000,
    );
  }

  componentDidUpdate(prevProps) {
    if (
      !this.props.token &&
      this.props.location.path &&
      this.isLoginRequired(this.props.location.path)
    ) {
      window.location.replace("/login");
    }
    this.redirectIdo();
  }

  isLoginRequired(url) {
    return !(
      /(\/create-internal-account|\/create-client-account|\/create-business-unit-member-account)/g.test(
        url,
      ) ||
      /\/login/g.test(url) ||
      /\/resetpassword/g.test(url) ||
      /\/changepassword/g.test(url)
    );
  }

  retrieveSession(session) {
    this.session = JSON.parse(session);
  }

  requireLogin() {
    //return !(this.props.token && this.props.tokenExpirationTime > moment().valueOf());
    //TODO:
    return !(
      this.props.token && this.props.tokenExpirationTime > moment().valueOf()
    );
  }
  handleLoginSubmit(email, password) {
    this.props.handleLoginSubmit(email, password);
  }

  handleLoginClose() {
    this.props.handleLoginClose();
  }
  getContent() {
    // only return content if token is defined
    if (!this.requireLogin()) {
      return <Dashboard />;
    }

    return undefined;
  }

  getTokenAfterLogin() {
    if (this.props.token) {
      return {
        key: "session",
        val: {
          loginTime: new Date(),
          token: this.props.token,
          userId: this.props.userId,
          roleId: this.props.roleId,
          roleName: this.props.roleName,
          tokenExpirationTime: this.props.tokenExpirationTime,
          apiBuildNumber: this.props.apiBuildNumber,
        },
      };
    }
    return null;
  }

  activeAction() {
    if (this.isLoginRequired(this.props.location.path)) {
      if (
        this.requireLogin() ||
        this.session.apiBuildNumber !== this.props.apiBuildNumber
      )
        this.idleAction();
    }
  }

  idleAction() {
    this.props.handleLogout();
    setTimeout(function () {
      window.location.replace("/login");
    }, 1000);
  }

  render() {
    let needsLogin = false;
    if (this.isLoginRequired(this.props.location.path)) {
      if (
        this.session &&
        this.props &&
        !isNil(this.session.apiBuildNumber) &&
        this.session.apiBuildNumber !== this.props.apiBuildNumber
      )
        needsLogin = true;
      else needsLogin = isNil(this.props.token) && isObject(this.session);

      if (needsLogin === true) {
        this.idleAction();
      }
    }

    const timeout = 60000 * 60; // 60 minutes
    const displayToolbar = !(
      /^\/login/g.test(this.props.location.path) ||
      /^\/resetpassword/g.test(this.props.location.path) ||
      /^\/changepassword/g.test(this.props.location.path)
    );
    return (
      <IdleTimer
        ref="idleTimer"
        element={document}
        activeAction={this.activeAction.bind(this)}
        idleAction={this.idleAction.bind(this)}
        timeout={timeout}
        format="MM-DD-YYYY HH:MM:ss.SSS"
      >
        <div id="AcquireAnywhere">
          {displayToolbar && <MainNav {...this.props} />}
          {displayToolbar && <HomeNav {...this.props} />}
          <div id="AcquireAnywhereMain">{this.props.children}</div>
          <LocalStorage
            retrieve="session"
            onRetrieve={this.retrieveSession.bind(this)}
            store={this.getTokenAfterLogin()}
          />
        </div>
      </IdleTimer>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App/index.js